<template>
  <tutorial-layout
    title="Custom Components"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">Overview text goes here.</p>
  </tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
export default {
  name: "VModel",
  mixins: [uiView],
  created() {},
  data() {
    return {
      text1: "Example Text",
    };
  },
  components: { tutorialLayout },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
        {
          title: "Data binding to custom components",
          href:
            "https://www.digitalocean.com/community/tutorials/vuejs-add-v-model-support",
        },
        {
          title: "V-model to custom components",
          href:
            "https://www.digitalocean.com/community/tutorials/how-to-add-v-model-support-to-custom-vue-js-components",
        },
        {
          title: "Creating custom inputs",
          href:
            "https://www.smashingmagazine.com/2017/08/creating-custom-inputs-vue-js/",
        },
      ];
    },
    youtubeLinks() {
      return [
        {
          title: "Custom Input Components",
          href: "https://www.youtube.com/embed/hsat438PfSU",
        },
        {
          title: "Reusable Vue components",
          href: "https://www.youtube.com/embed/HVzYir_0Kgg",
        },
        {
          title: "Components Custom Event",
          href: "https://www.youtube.com/embed/5eDG7HYEOvk",
        },
      ];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
</style>
